import { DBP_BASE_URL, DBP_KEY } from '../../common/util/dbp';
import { deaccent } from "../helpers";
export class LanguageSearchDropdown {

    languageComponent;
    searchbarComponent;
    listSelector;
    languages = [];
    languageParam;

    onLanguageChange;
    onSearchbarValueChange;

    //callbacks
    afterChange;

    constructor({ elementId, searchbarElId, listSelector, languageParam}) {
        this.languageComponent = document.getElementById(elementId);
        this.searchbarComponent = document.getElementById(searchbarElId);
        this.listSelector = listSelector;
        this.languageParam = languageParam;

        this.createCallbacks();
    }
    createCallbacks() {
        this.onSearchbarValueChange = (key, value) =>
            this.setLanguageAutocomplete(
              key,
              value,
              this.languages.map((lang) => lang.language_english),
              this
            );
        
        this.onLanguageChange = function (language) {
            this.languageComponent.style.display = "none";
            this.handleLanguageChange(language, this, false);
            this.setSearchbar(this.searchbarComponent, language);
        };
        
        this.searchbarComponent.onclick = this.searchbarComponent.onkeyup = (e) => {
            this.onSearchbarValueChange(e.which, e.target.value);
        };
    
        this.searchbarComponent.addEventListener("keyup", (ev) => this.handleLanguageAutocompleteInteraction(ev, this));
        this.languageComponent.addEventListener("mouseover", (ev) => this.handleLanguageAutocompleteInteraction(ev, this));
    
        this.searchbarComponent.addEventListener("keydown", function (e) {
            if (e.which == 40 || e.which == 38 || e.which == 13) {
                e.preventDefault(); // stops left and right cursor movement
            }
        });

        //	Loads all the languages
        //	Also calls function that reads url to display version in url (if any)
        getLanguages()
        .then( (data) => this.loadDropdownLanguages(data, this))
        .catch( console.error )
        .finally(() => {
            document.querySelectorAll(this.listSelector).forEach((el) => {
                el.style["max-height"] = "300px";
            });
        });
    }
        
    handleLanguageChange(lang, component, version = "ENGESVN2DA") {
      const selectedLang = component.languages.find(
        (language) => language.language_english.toLowerCase() === lang?.toLowerCase()
      ) || {
        language_english: "English",
        language_family_code: "ENG",
      };
      component.afterChange(selectedLang, version);//fetchVersions(selectedLang, version);
    }
    setLanguageAutocomplete(key, value, languageList, component) {
        if (key !== 38 && key !== 40 && key !== 13) {
          let matches;
          let i;
    
          const _ret = (function () {
            const div = component.languageComponent;
            div.innerHTML = "";
            div.style.display = "none";
    
            const search = deaccent(value).toLowerCase();
            matches = 0;
    
            if (search.length > 0) {
              div.style.display = "block";
    
              const _loop = function _loop() {
                if (matches > 7) {
                  return {
                    v: {
                      v: void 0,
                    },
                  };
                }
                const languageName = languageList[i];
                if (deaccent(languageName).toLowerCase().search(search) == 0) {
                  matches++;
                  const matchedText = languageName.slice(0, search.length);
                  const restOfText = languageName.slice(search.length);
                  const d = document.createElement("div");
                  d.innerHTML = "<strong>" + matchedText + "</strong>" + restOfText;
                  d.onclick = function () {
                    component.onLanguageChange(languageName);
                  };
                  div.appendChild(d);
                }
              };
    
              for (i = 0; i < languageList.length; i++) {
                const _ret2 = _loop();
    
                if (typeof _ret2 === "object") return _ret2.v;
              }
    
              if (matches == 0) {
                div.style.display = "none";
                console.log("no matches");
              }
            }
          })();
    
          if (typeof _ret === "object") return _ret.v;
        }
      }
    
      handleLanguageAutocompleteInteraction(e, component) {
        const div = component.languageComponent;
        let active = div.querySelector(".isActive");
    
        if (div.style.display === "block") {
          if (e.type === "mouseover" && e.target.nodeName.toLowerCase() != "strong") {
            if (active) {
              active.classList.remove("isActive");
            }
            active = e.target;
            active.classList.add("isActive");
          } else if (e.type == "keyup" && (e.which == 40 || e.which == 38)) {
            e.preventDefault();
    
            if (active) {
              active.classList.remove("isActive");
            }
    
            if (e.which == 40) {
              //	down
              active = !active ? div.firstChild : active.nextElementSibling || active;
            } else if (e.which == 38) {
              // up
              if (!active) {
                return;
              }
              active = active.previousElementSibling || active;
            }
            active.classList.add("isActive");
            component.setSearchbar(component.searchbarComponent, active.innerText);
          } else if (e.type == "keyup" && e.which == 13) {
            //	enter was pressed
            if (active) {
              component.onLanguageChange(active.innerText);
            }
          }
        }
      }
     
      setSearchbar(searchbarComponent,text) {
        searchbarComponent.value = text;
      }
  
      async loadDropdownLanguages( data, component) {
        component.languages = data;
      
        component.handleLanguageChange(this.languageParam, component, "ENGESVN2DA");
        component.setSearchbar(this.searchbarComponent, this.languageParam || "English");
      }
}
export async function getLanguages() {
    const baseUrl = `${DBP_BASE_URL}/api/languages?v=4&key=${DBP_KEY}&limit=150`;
  
    const { data: { data, meta: { pagination } } } = await FCBH.axiosInstance.get( baseUrl );
  
    const response = await Promise.all( prepareLanguagesRequest( baseUrl, pagination.total_pages ) )
  
    return [].concat( getMappedLanguages( data ), flattenLanguages( response ) );
  }
  function prepareLanguagesRequest( baseUrl, totalPages = 0 ){
    const requests = [];
  
    for (let page = 2; page < totalPages + 1; page++) {
      requests.push(FCBH.axiosInstance.get( `${baseUrl}&page=${page}` ) )
    }
  
    return requests;
  }
  
  function flattenLanguages( response ){
    return response.reduce( ( arr, res ) => arr.concat( getMappedLanguages( res.data.data ) ), []);
  }
  
  function getMappedLanguages( data ){
    return data.map( x => ( { 
        language_english: x.name,
        language_family_code: x.iso?.toUpperCase(),
        language_name: x.autonym, 
      } )
    ); 
  }